// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { fade } from '../../../LEGACY/colorUtils'

export class DotIcon extends Component {
  render() {
    const { url, color, style } = this.props
    const containerStyle = {
      ...style,
      width: 40,
      height: 40,
      border: `3px solid ${fade(colors.black, 0)}`,
      borderRadius: 20,
      textAlign: 'center',
      backgroundColor: color || colors.grey
    }

    const imgStyle = {
      width: 'auto',
      height: 18,
      marginTop: 8
      // background: `url(${url})`
    }

    return (
      <div className="lmc-timeline-dot" style={containerStyle}>
        <img alt="" className="lmc-dot-icon" src={url} style={imgStyle} />
      </div>
    )
  }
}

DotIcon.propTypes = {
  url: PropTypes.number.isRequired,
  color: PropTypes.object.isRequired
}

export default DotIcon
